// extracted by mini-css-extract-plugin
module.exports = {"max_width":"600px","padding_width":"14px","black_color":"#424242","gray_color":"#e0e0e0","red_color":"#ef5350"};